import { axiosPatientInstance } from "config";
import { useQuery } from "react-query";
import { SectionSuggestionDto } from "../api/mutations/useConversationLogMutations";

type UseSectionSuggestionsOptions = {
  enabled?: boolean;
};

function useSectionSuggestions(
  encounterId: string,
  sectionCode?: string,
  options: UseSectionSuggestionsOptions = {}
) {
  const { enabled = true } = options;
  const queryUrl = sectionCode
    ? `v1/conversation-log/${encounterId}/suggestions?sectionCode=${sectionCode}`
    : `v1/conversation-log/${encounterId}/suggestions`;

  return useQuery<SectionSuggestionDto[], Error>(
    [
      "sectionSuggestions",
      {
        encounterId,
        sectionCode: sectionCode ?? "ALL",
        enabled,
      },
    ],
    () =>
      axiosPatientInstance
        .get<SectionSuggestionDto[]>(queryUrl)
        .then((response) => response.data),
    {
      enabled: Boolean(encounterId) && enabled,
    }
  );
}

export { useSectionSuggestions };
export type { SectionSuggestionDto, UseSectionSuggestionsOptions };
